<script setup lang="ts">
  import { usePromiseDialogState } from '~/composables/use-promise-dialog'

  const activeDialog = usePromiseDialogState()
</script>

<template>
  <div class="contents" data-promise-dialog-wrapper>
    <component
      :is="activeDialog.component"
      v-if="activeDialog"
      :key="activeDialog.id"
      v-bind="activeDialog.props"
    />
  </div>
</template>
